import { createRouter, createWebHistory } from 'vue-router'
import RegistrationView from '../views/Registration.vue'
import RegistrationEdstackView from '../views/RegistrationEdstack.vue'
import VerificationView from '../views/Verification.vue'
import ConflictLogsView from '../views/ConflictLogs.vue'
import ConflictStudentsView from '../views/ConflictStudents.vue'
import SuccessScansView from '../views/SuccessScans.vue'

const routes = [
  {
    path: '/register',
    name: 'RegistrationView',
    component: RegistrationView
  },
  // edstack-fe iframe: modern full-view enrollment UI
  {
    path: '/register-edstack',
    name: 'RegistrationEdstackView',
    component: RegistrationEdstackView
  },
  // Admin: review and repair failed / mis-identified scans
  {
    path: '/conflicts',
    name: 'ConflictLogsView',
    component: ConflictLogsView
  },
  // Same conflicts rolled up per student, to avoid resolving one person twice
  {
    path: '/conflicts/students',
    name: 'ConflictStudentsView',
    component: ConflictStudentsView
  },
  {
    path: '/conflicts/scans',
    name: 'SuccessScansView',
    component: SuccessScansView
  },
  {
    path: '/',
    name: 'VerificationView',
    component: VerificationView
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
